document.addEventListener("DOMContentLoaded", function () {

  function formatDate(date) {
    const days = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
    const months = [
      "Jan","Feb","Mar","Apr","May","Jun",
      "Jul","Aug","Sep","Oct","Nov","Dec"
    ];

    return days[date.getDay()] + ", " + date.getDate() + " " + months[date.getMonth()];
  }

  const today = new Date();

  const shipDate = new Date(today);
  shipDate.setDate(today.getDate() + 2);

  const deliveryDate = new Date(today);
  deliveryDate.setDate(today.getDate() + 5);

  const processing = document.getElementById("processing-date");
  const ship = document.getElementById("ship-date");
  const delivery = document.getElementById("delivery-date");

  if (processing) {
    processing.innerHTML = formatDate(today);
  }

  if (ship) {
    ship.innerHTML = formatDate(shipDate);
  }

  if (delivery) {
    delivery.innerHTML = formatDate(deliveryDate);
  }

});